// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationResponseLineItemAdjudicationCode {
    static getAttributeTypeMap() {
        return ClaimAdjudicationResponseLineItemAdjudicationCode.attributeTypeMap;
    }
}
ClaimAdjudicationResponseLineItemAdjudicationCode.discriminator = undefined;
ClaimAdjudicationResponseLineItemAdjudicationCode.additionalProperties = false;
ClaimAdjudicationResponseLineItemAdjudicationCode.attributeTypeMap = [
    {
        "name": "carc",
        "baseName": "carc",
        "type": "string"
    },
    {
        "name": "rarc",
        "baseName": "rarc",
        "type": "string"
    },
];
//# sourceMappingURL=claimAdjudicationResponseLineItemAdjudicationCode.js.map